(function($) {
  var CHAR_MAX = 10;
  var SYMBOL_COST = 2;
  var SIDE_LABELS = ['Vorderseite', 'Rückseite'];
  var sideModes = ['zeichen', 'zeichen'];
  function getSideMode(index) { return sideModes[index] || 'zeichen'; }
  var previewSideCount = 1;
  var physicalSideMap = [0];

  function setPhysicalSideMap(map) {
    physicalSideMap = Array.isArray(map) && map.length ? map.slice() : [0];
  }

  function getPhysicalSideIndex(uiSideIndex) {
    if (physicalSideMap[uiSideIndex] != null) return physicalSideMap[uiSideIndex];
    return uiSideIndex;
  }

  window.lw040SetPhysicalSideMap = setPhysicalSideMap;

  var KE014_FONT = {
    name: 'G02',
    family: 'NirmalaS, sans-serif'
  };

  var KE014_PREVIEW_IMAGES = {
    silver: window.VIV_LW040.bild_lw040_preview_silver_png,
    gold: window.VIV_LW040.bild_lw040_preview_gold_png,
    rosegold: window.VIV_LW040.bild_lw040_preview_rosegold_png,
    silverVorder: window.VIV_LW040.bild_lw040_preview_silver_vorder_png,
    goldVorder: window.VIV_LW040.bild_lw040_preview_gold_vorder_png,
    rosegoldVorder: window.VIV_LW040.bild_lw040_preview_rosegold_vorder_png
  };


  /* ---- Motive: W-Reihe (2026-08-07) --------------------------------------
     Loest die alte C-Reihe ab — Beschluss Yin: eine einzige Icon-Familie im
     ganzen Shop, Referenz ist KE008. Satz = KE008s zehn + Pfote (W31) = elf.

     ★ Der Bestand kommt jetzt aus DIESER Datei. Frueher wurde er aus dem
     Template-Picker (.product_info_image_json, die alten C1–C50) ausgefiltert
     — das Snippet war also davon abhaengig, dass im Template noch der alte
     Picker steckt. Diese Abhaengigkeit ist damit weg.

     ⚠️ Dateinamen sind unregelmaessig: w01–w10 zweistellig, ab W11
     dreistellig (w011, w027, w031 …). Nicht "vereinheitlichen". */
  var KE014_SYMBOL_NAMES = {
    'w01.png': 'Mini Herz',
    'w02.png': 'Herz',
    'w03.png': 'Doppelherz',
    'w05.png': 'Infinity',
    'w06.png': 'Jesusfisch',
    'w07.png': 'Kreuz',
    'w09.png': 'Engel',
    'w027.png': 'Anker',
    'w031.png': 'Pfote',
    'w036.png': 'Fee',
    'w041.png': 'Stern'
  };

  /* Fixed LW042 shop icon assets — template 2026-kreuz-armband-lw040 */
  var KE014_SYMBOLS_FIXED = [
    { code: 'W01', text: 'Mini Herz',  image: window.VIV_LW040.bild_w01_png },
    { code: 'W02', text: 'Herz',       image: window.VIV_LW040.bild_w02_png },
    { code: 'W03', text: 'Doppelherz', image: window.VIV_LW040.bild_w03_png },
    { code: 'W05', text: 'Infinity',   image: window.VIV_LW040.bild_w05_png },
    { code: 'W06', text: 'Jesusfisch', image: window.VIV_LW040.bild_w06_png },
    { code: 'W07', text: 'Kreuz',      image: window.VIV_LW040.bild_w07_png },
    { code: 'W09', text: 'Engel',      image: window.VIV_LW040.bild_w09_png },
    { code: 'W27', text: 'Anker',      image: window.VIV_LW040.bild_w027_png },
    { code: 'W31', text: 'Pfote',      image: window.VIV_LW040.bild_w031_png },
    { code: 'W36', text: 'Fee',        image: window.VIV_LW040.bild_w036_png },
    { code: 'W41', text: 'Stern',      image: window.VIV_LW040.bild_w041_png }
  ];

  /* Altwerte: KH1–KH8 aus der ersten Generation, plus die eine echte
     Umbenennung der W-Reihe (Fisch → Jesusfisch). Ohne diesen Alias faende
     getSymbol() ein altes "Fisch" nicht mehr und das Motiv fiele im
     wiederhergestellten Warenkorb stillschweigend weg. */
  var KE014_KH_LEGACY = {
    'KH1': 'Mini Herz',
    'KH2': 'Herz',
    'KH3': 'Doppelherz',
    'KH4': 'Infinity',
    'KH5': 'Jesusfisch',
    'KH6': 'Anker',
    'KH7': 'Engel',
    'KH8': 'Pfote',
    'Fisch': 'Jesusfisch',
    'Christenfisch': 'Jesusfisch'
  };

  var lw040SymbolsCache = null;

  function imageFileFromUrl(url) {
    return String(url || '').split('/').pop().split('?')[0];
  }

  function normalizeLw040SymbolName(text, imageUrl) {
    var file = imageFileFromUrl(imageUrl);
    if (KE014_SYMBOL_NAMES[file]) return KE014_SYMBOL_NAMES[file];
    if (KE014_KH_LEGACY[text]) return KE014_KH_LEGACY[text];
    return text;
  }

  function normalizeLw040StoredSymbol(name) {
    if (!name) return '';
    return KE014_KH_LEGACY[name] || name;
  }

  /* Nur noch die eigene Liste — kein Umweg mehr ueber den Template-Picker.
     Damit ist die Reihenfolge garantiert und ein aufgeraeumtes Template kann
     den Bestand nicht mehr leerlaufen lassen. */
  function loadLw040Symbols() {
    if (lw040SymbolsCache) return lw040SymbolsCache;
    lw040SymbolsCache = KE014_SYMBOLS_FIXED.slice();
    return lw040SymbolsCache;
  }

  /* Bestellwert = "Anzeigename | CODE" (z. B. "Jesusfisch | W06").
     Der Code ist der einzige Weg, wie der Auftrags-Parser das Bild findet. */
  function formatSymbolOrderValue(name) {
    var resolved = normalizeLw040StoredSymbol(name);
    if (!resolved) return '';
    var symbols = loadLw040Symbols();
    for (var i = 0; i < symbols.length; i++) {
      if (symbols[i].text === resolved) {
        return symbols[i].code ? (resolved + ' | ' + symbols[i].code) : resolved;
      }
    }
    return resolved;
  }

  /* ★ Feldname ist die Bedingung dafuer, dass der Auftrags-Parser ein Bild
     zeigt: "… Motiv" → Code wird aufgeloest; "… Text + Motiv" → er trennt
     "Text(Motiv)" selbst und loest den Klammerinhalt auf. Ein Motiv unter dem
     Label "Text" bleibt fuer immer bildlos. `withCode` nur fuer die
     Bestellzeile — in der Kundenbestaetigung waere "| W06" nur Rauschen. */
  function symbolOrderRow(title, engraving, withCode) {
    var text = $.trim(engraving.text || '');
    var sym = withCode
      ? formatSymbolOrderValue(engraving.symbol)
      : normalizeLw040StoredSymbol(engraving.symbol);
    if (text && sym) return { name: title + ' Text + Motiv', value: text + '(' + sym + ')' };
    if (sym)         return { name: title + ' Motiv',        value: sym };
    return { name: title + ' Text', value: text };
  }

  /*
   * Preview calibration for lw040-preview-*.png (front left, back right in one image).
   * Back positions mirror front: same top, left = 100 - left.
   */
  function mirrorPreviewPos(pos) {
    return { top: pos.top, left: Math.round((100 - pos.left) * 10) / 10 };
  }

  var PREVIEW_TEXT = { top: 52.4, left: 24.3 };
  var PREVIEW_ICON = { top: 52.4, left: 25.2 };
  var PREVIEW_TEXT_BACK = { top: 52.4, left: 74.8 };
  var PREVIEW_ICON_BACK = mirrorPreviewPos(PREVIEW_ICON);

  function getActiveSideCount() {
    var domCount = $('.up-Fenster-p-personalization-1 [class*="product_info_main_"]').length;
    return domCount > 0 ? domCount : previewSideCount;
  }

  function esc(s) {
    return String(s || '').replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  }

  function getColorKeyFromOption1() {
    var label = ($('[name="option1"]').attr('data-value') || '').toLowerCase();
    if (label.indexOf('ros') !== -1) return 'rosegold';
    if (label.indexOf('gold') !== -1 && label.indexOf('ros') === -1) return 'gold';
    return 'silver';
  }

  function ensureLw040GravurConfig() {
    if (window.lw040GravurConfig || typeof window.lwGravurResolveOption2 !== 'function') {
      return;
    }
    var config = window.lwGravurResolveOption2($('[name="option2"]').attr('data-value') || '');
    if (config) {
      window.lwGravurConfig = config;
      window.lw040GravurConfig = config;
    }
  }

  function usesFrontOnlyPreviewBase() {
    ensureLw040GravurConfig();
    var sides = window.lw040GravurConfig && window.lw040GravurConfig.physicalSides;
    return Array.isArray(sides) && sides.length === 1 && sides[0] === 0;
  }

  function getColorPreviewUrl() {
    var colorKey = getColorKeyFromOption1();
    if (usesFrontOnlyPreviewBase()) {
      return KE014_PREVIEW_IMAGES[colorKey + 'Vorder'] || KE014_PREVIEW_IMAGES[colorKey];
    }
    return KE014_PREVIEW_IMAGES[colorKey] || KE014_PREVIEW_IMAGES.silver;
  }

  function getSymbolByName(name) {
    if (!name) return null;
    var resolved = normalizeLw040StoredSymbol(name);
    var symbols = loadLw040Symbols();
    for (var i = 0; i < symbols.length; i++) {
      if (symbols[i].text === resolved || symbols[i].text === name) return symbols[i];
    }
    return null;
  }

  function weightedLength(str) {
    if (!str) return 0;
    var total = 0;
    var re = /\(([^)]+)\)/g;
    var last = 0;
    var match;
    while ((match = re.exec(str)) !== null) {
      total += match.index - last;
      total += SYMBOL_COST;
      last = re.lastIndex;
    }
    total += str.length - last;
    return total;
  }

  function getSideIndexFromEl($el) {
    var $side = $el.closest('[class*="product_info_main_"]');
    if (!$side.length) return NaN;
    var match = String($side.attr('class') || '').match(/product_info_main_(\d+)/);
    return match ? parseInt(match[1], 10) : NaN;
  }

  function getSideLabel(index) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + index);
    var title = $.trim($side.find('.pattles-message-header span').first().text());
    return title || SIDE_LABELS[index] || ('Seite ' + (index + 1));
  }

  function ensurePreviewShell() {
    var $host = $('.up-Fenster-p-personalization-1 .fenster-content-contentin');
    if (!$host.length) return;

    if (!$host.find('.lw040-preview-wrap').length) {
      $host.prepend(
        '<div class="lw040-preview-wrap">' +
          '<div class="lw040-preview-label">Vorschau</div>' +
          '<div class="lw040-preview-stage" data-lw040-preview-stage>' +
            /* NIE loading="lazy" (GOTCHAS 27): das Fenster faehrt von ausserhalb des
               Viewports herein — dort laedt der Browser ein lazy-Bild nicht, und er
               prueft es beim Hereinfahren auch nicht neu. Das Basisbild bliebe grau,
               ohne Fehler in der Konsole (complete=false, naturalWidth 0). Real
               gemessen bei KS017, A203 und A227; Bestand am 2026-09-15 bereinigt. */
            '<img class="lw040-preview-base" alt="">' +
            '<div class="lw040-preview-layers"></div>' +
          '</div>' +
        '</div>'
      );
    }
  }

  function renderAllPreviewEngravings() {
    var $layers = $('[data-lw040-preview-stage] .lw040-preview-layers');
    $layers.empty();
    var zu = getActiveSideCount();

    for (var i = 0; i < zu; i++) {
      var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + i);
      if (!$side.length) continue;

      var parts = getSideEngraving(i);
      var text = $.trim(parts.text || '');
      var symbol = normalizeLw040StoredSymbol(parts.symbol || '');
      if (!text && !symbol) continue;

      var physicalSide = getPhysicalSideIndex(i);
      var textPos = physicalSide === 1 ? PREVIEW_TEXT_BACK : PREVIEW_TEXT;
      var iconPos = physicalSide === 1 ? PREVIEW_ICON_BACK : PREVIEW_ICON;
      var textSideClass = physicalSide === 1 ? ' lw040-preview-text--back' : ' lw040-preview-text--front';
      var iconSideClass = physicalSide === 1 ? ' lw040-preview-icon--back' : ' lw040-preview-icon--front';

      if (text) {
        var textStyle = 'top:' + textPos.top + '%;left:' + textPos.left + '%;font-family:' + KE014_FONT.family + ';';
        $layers.append('<div class="lw040-preview-text' + textSideClass + '" style="' + textStyle + '">' + esc(text) + '</div>');
      }

      if (symbol) {
        var sym = getSymbolByName(symbol);
        if (sym && sym.image) {
          var iconStyle = 'top:' + iconPos.top + '%;left:' + iconPos.left + '%;';
          $layers.append(
            '<div class="lw040-preview-icon' + iconSideClass + '" style="' + iconStyle + '">' +
              '<img src="' + esc(sym.image) + '" alt="' + esc(symbol) + '">' +
            '</div>'
          );
        }
      }
    }
  }

  window.lw040UpdatePreview = function() {
    ensurePreviewShell();
    var baseUrl = getColorPreviewUrl();
    var $stage = $('[data-lw040-preview-stage]');
    $stage.find('.lw040-preview-base').attr('src', baseUrl);
    renderAllPreviewEngravings();
  };

  function parseEngravingValue(raw) {
    var val = raw || '';
    var match = val.match(/\(([^)]+)\)$/);
    if (match && getSymbolByName(match[1])) {
      return {
        text: val.substring(0, val.length - match[0].length),
        symbol: normalizeLw040StoredSymbol(match[1])
      };
    }
    return { text: val, symbol: '' };
  }

  function composeEngraving(text, symbol) {
    return (text || '') + (symbol ? '(' + symbol + ')' : '');
  }

  function getSideEngraving(sideIndex) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    var $input = $side.find('.text_class_' + sideIndex);
    var mode = $side.attr('data-lw040-mode') || 'zeichen';
    var symbol = normalizeLw040StoredSymbol($side.attr('data-lw040-symbol') || '');

    if (mode === 'symbol') {
      return { text: '', symbol: symbol };
    }

    return { text: $.trim($input.val() || ''), symbol: '' };
  }

  function getComposedEngraving(sideIndex) {
    var parts = getSideEngraving(sideIndex);
    if (parts.symbol) return '(' + parts.symbol + ')';
    return parts.text || '';
  }

  function captureSideEngraving(sideIndex) {
    return getSideEngraving(sideIndex);
  }

  function syncSymbolGridSelection(sideIndex) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    var selected = getSideEngraving(sideIndex).symbol;
    var $grid = $side.find('.lw040-symbol-grid');
    $grid.find('button').removeClass('is-active');
    if (selected) {
      $grid.find('button[data-symbol="' + selected + '"]').addClass('is-active');
    }
  }

  function setSymbolSelection(sideIndex, symName) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    var $input = $side.find('.text_class_' + sideIndex);
    if (!$input.length || !symName) return;
    symName = normalizeLw040StoredSymbol(symName);

    var current = normalizeLw040StoredSymbol($side.attr('data-lw040-symbol') || '');
    if (current === symName) {
      symName = '';
    }

    $side.attr('data-lw040-symbol', symName);
    $side.attr('data-lw040-mode', 'symbol');
    sideModes[sideIndex] = 'symbol';
    $input.val('');

    updateCharCounter($input, sideIndex);
    syncSymbolGridSelection(sideIndex);
    window.lw040UpdatePreview();
  }

  function buildSymbolGrid(sideIndex) {
    var symbols = loadLw040Symbols();
    var selected = getSideEngraving(sideIndex).symbol;
    var html = '<div class="lw040-symbol-grid" data-side="' + sideIndex + '">';
    for (var i = 0; i < symbols.length; i++) {
      var sym = symbols[i];
      var activeAttr = sym.text === selected ? ' class="is-active"' : '';
      html += '<button type="button"' + activeAttr + ' data-symbol="' + esc(sym.text) + '" title="' + esc(sym.text) + '">' +
        '<img src="' + esc(sym.image) + '" alt="' + esc(sym.text) + '" loading="lazy">' +
        '<span class="lw040-symbol-label">' + esc(sym.text) + '</span>' +
      '</button>';
    }
    html += '</div>';
    return html;
  }

  function applyFixedFont($input) {
    $input.css('font-family', KE014_FONT.family);
    $input.attr('data-font-family', KE014_FONT.name);
  }

  function updateCharCounter($input, sideIndex) {
    if (isNaN(sideIndex)) {
      sideIndex = getSideIndexFromEl($input);
    }
    var composed = isNaN(sideIndex) ? ($input.val() || '') : getComposedEngraving(sideIndex);
    var len = weightedLength(composed);
    var $words = $input.siblings('.number-header-words');
    $words.find('.number-1').text(len);
    $words.find('.wordsNum_v1').text(CHAR_MAX);
    if (composed) {
      $input.siblings('.number-header-icon').css('display', 'block');
    } else {
      $input.siblings('.number-header-icon').css('display', 'none');
    }
  }

  function setSideMode(sideIndex, mode) {
    sideModes[sideIndex] = mode;
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    var parts = captureSideEngraving(sideIndex);
    $side.attr('data-lw040-mode', mode);
    $side.find('.lw040-mode-switch button').removeClass('is-active');
    $side.find('.lw040-mode-switch button[data-mode="' + mode + '"]').addClass('is-active');

    var $textareaBlock = $side.find('.p-w-plattchen-list-number-header');
    var $tabParameter = $side.find('.pattles-tab-parameter');
    var $input = $side.find('.text_class_' + sideIndex);

    $side.find('.lw040-side-error').hide();
    $side.removeClass('has-error');

    if (mode === 'zeichen') {
      $tabParameter.show();
      $textareaBlock.show();
      $side.find('.font_main').hide();
      $side.find('.image_main').hide();
      $side.find('.lw040-symbol-grid').hide();
      $side.attr('data-type', 'text');
      $side.attr('data-lw040-symbol', '');
      $input.val(parts.text || '');
      $input.prop('readonly', false);
      applyFixedFont($input);
    } else if (mode === 'symbol') {
      $tabParameter.show();
      $textareaBlock.hide();
      $side.find('.font_main').hide();
      $side.find('.image_main').hide();
      var symbols = loadLw040Symbols();
      var $grid = $side.find('.lw040-symbol-grid');
      if (!$grid.length || $grid.find('button').length !== symbols.length) {
        $grid.remove();
        $side.find('.p-w-plattchen-list-number-header').after(buildSymbolGrid(sideIndex));
      } else {
        syncSymbolGridSelection(sideIndex);
      }
      $side.find('.lw040-symbol-grid').show();
      $side.attr('data-type', 'image');
      $side.attr('data-lw040-symbol', parts.symbol || '');
      $input.val('');
      applyFixedFont($input);
      syncSymbolGridSelection(sideIndex);
    }

    updateCharCounter($input, sideIndex);
    window.lw040UpdatePreview();
  }

  function bindSideEvents() {
    var $popup = $('.up-Fenster-p-personalization-1');

    $popup.find('.lw040-mode-switch button').off('click.lw040').on('click.lw040', function() {
      var idx = getSideIndexFromEl($(this));
      if (isNaN(idx)) return;
      setSideMode(idx, $(this).data('mode'));
    });

    /* [3] Kopfzeile klappt ihre Seite auf; die andere geht dabei zu. */
    $popup.off('click.lw040Side', '.lw040-side--klappbar > .pattles-message-header')
      .on('click.lw040Side', '.lw040-side--klappbar > .pattles-message-header', function() {
        var $side = $(this).parent();
        if ($side.hasClass('is-side-open')) return;
        var treffer = String($side.attr('class') || '').match(/product_info_main_(\d+)/);
        if (!treffer) return;
        lw040OpenSide(parseInt(treffer[1], 10), true);
      });

    $popup.off('click.lw040Symbol', '.lw040-symbol-grid button').on('click.lw040Symbol', '.lw040-symbol-grid button', function() {
      var idx = getSideIndexFromEl($(this));
      if (isNaN(idx)) return;
      var symName = $(this).attr('data-symbol');
      if (!symName) return;
      setSymbolSelection(idx, symName);
    });

    $popup.find('.number-header-textarea').off('input.lw040 propertychange.lw040').on('input.lw040 propertychange.lw040', function() {
      var $input = $(this);
      var idx = getSideIndexFromEl($input);
      if (isNaN(idx)) return;
      var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + idx);
      var mode = $side.attr('data-lw040-mode') || 'zeichen';

      if (mode === 'zeichen') {
        var text = $input.val() || '';
        $side.attr('data-lw040-symbol', '');
        while (weightedLength(text) > CHAR_MAX && text.length) {
          text = text.slice(0, -1);
        }
        $input.val(text);
      } else {
        return;
      }

      updateCharCounter($input, idx);
      window.lw040UpdatePreview();
    });

    $popup.find('.number-header-icon').off('click.lw040').on('click.lw040', function() {
      var $input = $(this).siblings('.number-header-textarea');
      var idx = getSideIndexFromEl($input);
      if (isNaN(idx)) return;
      var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + idx);
      $side.attr('data-lw040-symbol', '');
      $input.val('');
      updateCharCounter($input, idx);
      syncSymbolGridSelection(idx);
      $(this).css('display', 'none');
      window.lw040UpdatePreview();
    });
  }

  /* STEHENDES Kreuz mit EINER Oese oben. Die Masse sind am Basisbild
     lw040-preview-gold-vorder.png gemessen (2026-09-21, 1600x1600 px):
       Kreuz ohne Oese      x 180..628 (B 449) · y 616..1222 (H 607) → B:H 0,74
       senkrechter Balken   B 100 px = 22,3 % der Kreuzbreite
       Querbalken           H  99 px = 16,3 % der Kreuzhoehe,
                            Mitte y 840 = 36,9 % der Kreuzhoehe von oben
     Auf die viewBox umgerechnet mit Faktor 0,126. Die Oese greift um 1,4
     Einheiten in die Kreuzspitze, damit sie haengt statt aufzusitzen;
     gezeichnet wird sie zuerst, die weisse Balkenfuellung deckt den Rest.
     ⚠️ Bis 2026-09-21 stand hier ein LIEGENDES Kreuz mit ZWEI Oesen, aus dem
     LW101-Rezept uebernommen (5608c3c4). Diesen Anhaenger gibt es in dieser
     Vorlage nicht: LW040, HK016 und KS029 tragen alle dasselbe STEHENDE Kreuz
     mit einer Oese — dasselbe, das die Vorschau darueber zeigt.
     Wer die Koordinaten aendert, muss .lw040-layout-ovl (left/top) mitziehen:
     die Beispielgravur sitzt auf der Kreuzung x 50 / y 48,9. */
  var LW040_KREUZ_SVG =
    '<svg class="lw040-layout-kreuz" viewBox="0 0 100 100" aria-hidden="true">' +
      '<circle class="lw040-kreuz-oese" cx="50" cy="13.5" r="8.4"/>' +
      '<rect class="lw040-kreuz-linie" x="43.7" y="20.5" width="12.6" height="76.5" rx="6.3"/>' +
      '<rect class="lw040-kreuz-linie" x="21.7" y="42.7" width="56.6" height="12.5" rx="6.25"/>' +
      '<rect class="lw040-kreuz-fuellung" x="44.9" y="21.7" width="10.2" height="74.1" rx="5.1"/>' +
    '</svg>';

  function lw040BuildModeSwitch() {
    var herzSym = getSymbolByName('Herz');
    var herzImg = herzSym && herzSym.image
      ? '<img src="' + esc(herzSym.image) + '" alt="Herz">'
      : '&#9825;';

    function karte(mode, ovlClass, ovlHtml, name, sub) {
      return '<button type="button" data-mode="' + mode + '">' +
        '<span class="lw040-layout-icon">' +
          LW040_KREUZ_SVG +
          '<span class="lw040-layout-ovl' + ovlClass + '">' + ovlHtml + '</span>' +
        '</span>' +
        '<span class="lw040-layout-name">' + name + '</span>' +
        '<span class="lw040-layout-sub">' + sub + '</span>' +
      '</button>';
    }

    /* Die data-mode-Werte bleiben exakt die alten (zeichen / symbol) —
       setSideMode, Speicherstand und Bestellausgabe haengen daran. LW040 hat
       KEINEN Modus „Text mit Motiv" (anders als LW101). Getauscht wird nur
       das Aussehen. */
    return '<div class="lw040-mode-switch">' +
        karte('zeichen', '', 'Anna', 'Nur Text', 'z.B. ein Name') +
        karte('symbol', ' lw040-layout-ovl--gross', herzImg, 'Nur Motiv', 'nur ein Symbol') +
      '</div>' +
      '<p class="lw040-side-error">Bitte gib einen Gravurtext ein oder wähle ein Symbol.</p>';
  }

  function setupSide(sideIndex) {
    var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + sideIndex);
    if (!$side.length) return;

    $side.find('.pattles-tab-header').hide();

    /* Gravurstil-Karten (K530-Form): der Anhaenger als Strichbild, darauf die
       Beispielgravur an derselben waagerechten Position wie in der echten
       Vorschau. Die alten drei Textreiter werden ersetzt — erkennbar daran,
       dass die Karten-Auszeichnung fehlt. */
    if (!$side.find('.lw040-mode-switch .lw040-layout-icon').length) {
      $side.find('.lw040-mode-switch, .lw040-side-error').remove();
      $side.find('.pattles-message-header').after(lw040BuildModeSwitch());
    }

    var $input = $side.find('.text_class_' + sideIndex);
    if (typeof $side.attr('data-lw040-symbol') === 'undefined') {
      var initial = parseEngravingValue($input.val() || '');
      if (initial.symbol && !$.trim(initial.text)) {
        sideModes[sideIndex] = 'symbol';
        $side.attr('data-lw040-symbol', normalizeLw040StoredSymbol(initial.symbol));
        $input.val('');
      } else {
        sideModes[sideIndex] = 'zeichen';
        $side.attr('data-lw040-symbol', '');
        $input.val($.trim(initial.text || $input.val() || ''));
      }
    }
    applyFixedFont($input);
    $input.attr('placeholder', 'Gib deinen Gravurtext ein.');
    $input.attr('maxlength', 40);

    var $words = $side.find('.number-header-words');
    if ($words.length) {
      $words.html('<span class="number-1">0</span> / <span class="wordsNum_v1">' + CHAR_MAX + '</span>');
    }

    setSideMode(sideIndex, sideModes[sideIndex] || 'zeichen');
  }

  /* ==================================================================
     FOKUS — K530-Anzeigestandard (Yin 2026-08-15). Nur Darstellung und
     Bedienung; die Bestell-Eigenschaften bleiben Zeichen fuer Zeichen
     unveraendert.
     ================================================================== */

  function lw040SideEl(index) {
    return $('.up-Fenster-p-personalization-1 .product_info_main_' + index);
  }

  function lw040AlleSeiten() {
    return $('.up-Fenster-p-personalization-1 [class*="product_info_main_"]');
  }

  function lw040ScrollEl() {
    return $('.up-Fenster-p-personalization-1')
      .find('.fenster-content-inner, .fenster-content-contentin').get(0);
  }

  function lw040ScrollSideIntoView($side) {
    var scrollEl = lw040ScrollEl();
    if (!scrollEl || !$side || !$side.length) return;
    var top = $side[0].getBoundingClientRect().top
      - scrollEl.getBoundingClientRect().top + scrollEl.scrollTop - 8;
    scrollEl.scrollTop = Math.max(0, top);
  }


  /* [3] Seiten-Akkordeon: nur bei beidseitiger Gravur, dann ist immer genau
     eine Seite offen. Der Zustand ueberlebt den Neuaufbau des Popups. */
  var lw040OffeneSeite = 0;

  function lw040EnsureChevron($side) {
    var $head = $side.children('.pattles-message-header');
    /* Der Titel-<span> bleibt das ERSTE Kind — getSideLabel liest ihn per
       .first(), das Chevron haengt dahinter. */
    if ($head.length && !$head.children('.lw040-side-chev').length) {
      $head.append('<span class="lw040-side-chev" aria-hidden="true">▾</span>');
    }
  }

  function lw040OpenSide(index, scrollen) {
    var $sides = lw040AlleSeiten();
    if (!$sides.filter('.lw040-side--klappbar').length) return;
    lw040OffeneSeite = index;
    $sides.removeClass('is-side-open');
    var $ziel = lw040SideEl(index).addClass('is-side-open');
    if (scrollen) lw040ScrollSideIntoView($ziel);
  }

  function lw040ApplyAkkordeon(zu) {
    var $sides = lw040AlleSeiten();
    if (zu < 2) {
      /* Einseitig: kein Akkordeon — die Klasse wegnehmen, damit die
         Zuklapp-Regeln nichts verstecken koennen. */
      $sides.removeClass('lw040-side--klappbar').addClass('is-side-open');
      return;
    }
    $sides.addClass('lw040-side--klappbar').each(function() {
      lw040EnsureChevron($(this));
    });
    var ziel = (lw040OffeneSeite >= 0 && lw040OffeneSeite < zu) ? lw040OffeneSeite : 0;
    $sides.removeClass('is-side-open');
    lw040SideEl(ziel).addClass('is-side-open');
    lw040OffeneSeite = ziel;
  }

  window.lw040ValidateBeforeOpen = function() { return true; };

  window.lw040AfterUpdateSize = function(zu) {
    if (window.lw040GravurConfig && window.lw040GravurConfig.physicalSides) {
      setPhysicalSideMap(window.lw040GravurConfig.physicalSides);
    } else {
      var parsedZu = parseInt(zu, 10) || 0;
      var defaultMap = [];
      for (var mapIndex = 0; mapIndex < parsedZu; mapIndex++) defaultMap.push(mapIndex);
      setPhysicalSideMap(defaultMap);
    }

    zu = parseInt(zu, 10) || 0;
    if (zu < 1) {
      return;
    }
    zu = Math.min(zu, 2);
    previewSideCount = zu;
    ensurePreviewShell();
    for (var i = 0; i < zu; i++) {
      setupSide(i);
    }
    lw040ApplyAkkordeon(zu);
    bindSideEvents();
    window.lw040UpdatePreview();
  };

  window.lw040OnPopupOpen = function() {
    lw040SymbolsCache = null;
    if (window.lw040RefreshPopupSides) {
      lw040RefreshPopupSides();
    }
    ensurePreviewShell();
    var $sides = $('.up-Fenster-p-personalization-1 [class*="product_info_main_"]');
    previewSideCount = $sides.length || previewSideCount;
    if (window.lw040AfterUpdateSize) {
      lw040AfterUpdateSize(previewSideCount);
    } else {
      bindSideEvents();
      window.lw040UpdatePreview();
    }
  };

  window.lw040OnPopupClose = function() {
    $('.product-info--lw040 [class*="product_info_main_"]').removeClass('has-error');
  };

  window.lw040ValidateSides = function(zu) {
    zu = Math.min(Math.max(parseInt(zu, 10) || 1, 1), 2);
    var valid = true;
    var ersteFehlerSeite = -1;
    for (var i = 0; i < zu; i++) {
      var $side = $('.up-Fenster-p-personalization-1 .product_info_main_' + i);
      var mode = getSideMode(i);
      $side.removeClass('has-error');
      $side.find('.lw040-side-error').hide();
      $side.find('.text_class_' + i).parent().removeClass('error');

      var engraving = getSideEngraving(i);
      var sideValid = false;
      if (mode === 'symbol_text') {
        sideValid = !!$.trim(engraving.text) && !!engraving.symbol;
      } else {
        sideValid = !!$.trim(getComposedEngraving(i));
      }

      if (!sideValid) {
        valid = false;
        $side.addClass('has-error');
        $side.find('.text_class_' + i).parent().addClass('error');
        $side.find('.lw040-side-error').show();
        if (ersteFehlerSeite < 0) ersteFehlerSeite = i;
      }
    }
    if (!valid) {
      /* [6] Fokus-Regel: nur die ERSTE fehlerhafte Seite aufklappen und
         anspringen. Weitere fehlerhafte Seiten tragen am zugeklappten Kopf
         ein rotes „!" und kommen beim naechsten Klick der Reihe nach dran. */
      if (ersteFehlerSeite >= 0) lw040OpenSide(ersteFehlerSeite, false);
      alert('Bitte fülle die Gravur für jede Seite aus.');
      if (ersteFehlerSeite >= 0) lw040ScrollSideIntoView(lw040SideEl(ersteFehlerSeite));
    }
    return valid;
  };

  window.lw040AppendSideProperties = function(properies_arr, zu, popup_title) {
    for (var i = 0; i < zu; i++) {
      var title = getSideLabel(i);
      if (popup_title) {
        var parts = String(popup_title).split(',');
        if (parts[i]) title = $.trim(parts[i]);
      }

      var engraving = getSideEngraving(i);
      var composed = composeEngraving(engraving.text, engraving.symbol);
      if (!$.trim(composed)) continue;

      var orderRow = symbolOrderRow(title, engraving, true);
      if ($.trim(orderRow.value)) properies_arr.push([orderRow.name, orderRow.value]);
      if (engraving.text) properies_arr.push([title + ' Font', KE014_FONT.name]);
    }
  };

  window.lw040ConfirmHtml = function(zu, popup_title) {
    var html = '';
    var template = $('#form_message_option2').html() || $('#form_message_option').html();
    if (!template) return '';

    for (var i = 0; i < zu; i++) {
      var title = getSideLabel(i);
      if (popup_title) {
        var parts = String(popup_title).split(',');
        if (parts[i]) title = $.trim(parts[i]);
      }

      var engraving = getSideEngraving(i);
      var composed = composeEngraving(engraving.text, engraving.symbol);
      if (!$.trim(composed)) continue;

      var confirmRow = symbolOrderRow(title, engraving, false);
      if ($.trim(confirmRow.value)) {
        html += template.replaceAll('{option_name}', confirmRow.name).replaceAll('{option_value}', confirmRow.value);
      }
      if (engraving.text) {
        html += template.replaceAll('{option_name}', title + ' Font').replaceAll('{option_value}', KE014_FONT.name);
      }
    }
    if (html) {
      /* [7] Platzhalter fuer den Vorschau-Streifen — befuellt wird er per
         DOM-Klon NACH dem Einhaengen der Bestaetigungsseite. */
      html = '<div class="lw040-confirm-vorschau" aria-hidden="true"></div>' + html;
    }
    return html;
  };

  /* [7] Vorschau-Streifen auf der Bestaetigungsseite: klont die live gerenderte
     Buehne aus dem Popup — gleiche Seite, gleiche Styles und Schrift, also
     pixelgleich zum Popup. LW040 hat GENAU EINE Buehne (bei beidseitiger
     Gravur zeigt das Basisbild beide Kreuze uebereinander), also eine Kachel.
     WICHTIG: beim Bestaetigen ist das Popup zu, die Buehne also 0 breit —
     darum vorher unsichtbar messbar machen (fixed, -9999px), frisch rendern,
     klonen, alles zurueckdrehen. */
  function lw040FillConfirmVorschau() {
    var $ziel = $('.message-confirm-item-2 .lw040-confirm-vorschau').last();
    if (!$ziel.length || $ziel.children().length) return;
    var $popup = $('.up-Fenster-p-personalization-1');
    if (!$popup.length) return;

    var altStyle = $popup.attr('style') || '';
    $popup.css({ display: 'block', visibility: 'hidden', position: 'fixed', left: '-9999px', top: '0' });
    window.lw040UpdatePreview();

    var $stage = $('[data-lw040-preview-stage]').first();
    var sw = $stage.length ? $stage[0].offsetWidth : 0;
    var sh = $stage.length ? $stage[0].offsetHeight : 0;
    if (sw && sh) {
      var ZIEL_B = Math.max(64, Math.min(130, $ziel.width() || 320));
      var f = ZIEL_B / sw;
      var $clip = $('<div class="lw040-cv-clip"></div>')
        .css({ width: ZIEL_B + 'px', height: Math.ceil(sh * f) + 'px', overflow: 'hidden' });
      var $scale = $('<div class="lw040-cv-scale"></div>')
        .css({ width: sw + 'px', transform: 'scale(' + f + ')', 'transform-origin': 'top left' });
      $scale.append($stage.clone());
      $clip.append($scale);
      var name = previewSideCount > 1
        ? 'VS · RS'
        : (physicalSideMap[0] === 1 ? 'RS' : 'VS');
      $ziel.append($('<div class="lw040-cv-item"></div>')
        .css('width', ZIEL_B + 'px')
        .append($clip)
        .append('<div class="lw040-cv-name">' + esc(name) + '</div>'));
    }

    $popup.attr('style', altStyle);
  }

  window.lw040EnhanceConfirmOptions = function() {
    /* laeuft im Event-File VOR dem Einhaengen von .message-confirm-item-2 —
       der Handler dort ist synchron, also reicht ein Tick Verzoegerung. */
    setTimeout(lw040FillConfirmVorschau, 0);
  };




  $(document).on('change.lw040Color', '[name="option1"]', function() {
    if ($('.up-Fenster-p-personalization-1').hasClass('open')) {
      window.lw040UpdatePreview();
    }
  });

  $(document).on('change.lw040GravurOption', '[name="option2"]', function() {
    window.lw040GravurConfig = null;
    window.lwGravurConfig = null;
    if ($('.up-Fenster-p-personalization-1').hasClass('open')) {
      window.lw040UpdatePreview();
    }
  });

})(jQuery);
